// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__3uNic"};